import { hasLayers } from "@escapio/shared/components/dialogs/StackManager";
import { watch as watchInteraction } from "@escapio/shared/event/interaction-observer";

import { travelData } from "@escapio/portal/state/travelData";
import { hasBeenShown as calendarShown } from "./travel-data/CalendarDialog";
import { show as openNewsletterPopup } from "@escapio/portal/components/newsletter/PopupOpener";
import { hasUIShown } from "@escapio/shared/tracker/ConsentObserver";

export const register = openCalendarCallback =>
	window.addEventListener("load", async () => {
		await watchInteraction();

		try {
			await hasUIShown;
			return;
		} catch {
			// Go on.
		}

		if (calendarShown() || hasLayers() || travelData.hasDates) {
			// Try open NL-Popup.
			await openNewsletterPopup();
			return;
		}
		openCalendarCallback();
	});
